var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82167 42.2263H21.6388L39.2348 56.6136C39.5395 56.8636 39.9233 57 40.307 57C40.5553 57 40.8036 56.9432 41.0293 56.8295C41.6163 56.5454 42 55.9431 42 55.2953V8.70123C42 8.05346 41.6388 7.46251 41.0632 7.1784C40.4876 6.89429 39.7991 6.95111 39.2912 7.3375L21.6727 20.6339H9.82167C8.26411 20.6339 7 21.9067 7 23.475V39.3852C7 40.9534 8.26411 42.2263 9.82167 42.2263Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.476 20.5011C48.8413 21.1808 48.8413 22.2752 49.476 22.9434C53.8755 27.6551 53.8755 35.3391 49.476 40.0508C48.8413 40.7305 48.8413 41.8249 49.476 42.4931C49.7879 42.8272 50.2075 43 50.6162 43C51.025 43 51.4445 42.8272 51.7564 42.4931C57.4145 36.4335 57.4145 26.5607 51.7564 20.5011C51.1325 19.833 50.1106 19.833 49.476 20.5011Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8778 23.5252C46.2152 22.8249 45.1483 22.8249 44.497 23.5252C43.8343 24.2255 43.8343 25.3531 44.497 26.0415C45.8783 27.5015 46.6308 29.4362 46.6308 31.5015C46.6308 33.5668 45.8671 35.5015 44.497 36.9614C43.8343 37.6617 43.8343 38.7893 44.497 39.4777C44.8226 39.822 45.2606 40 45.6874 40C46.1142 40 46.5521 39.822 46.8778 39.4777C48.8881 37.3531 49.9999 34.5163 49.9999 31.5015C50.0111 28.4866 48.8993 25.6617 46.8778 23.5252Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn);
export default __webpack_public_path__ + "static/media/sound_on.e3cb65cf.svg";
export { ForwardRef as ReactComponent };